module.exports = __webpack_public_path__ + "img/sort-up-solid.9b0e128.svg";